// @mui
import { alpha } from '@mui/material/styles';
//
import palette from './palette';

// ----------------------------------------------------------------------

export default function customShadows(mode = 'light') {
  const isLight = mode === 'light';
  const color = isLight ? palette.grey[500] : '#000000';
  const pal = palette(mode);
  const transparent = alpha(color, isLight ? 0.16 : 0.4);

  return {
    z1: `0 1px 2px 0 ${transparent}`,
    z4: `0 4px 8px 0 ${transparent}`,
    z8: `0 8px 16px 0 ${transparent}`,
    z12: `0 12px 24px -4px ${transparent}`,
    z16: `0 16px 32px -4px ${transparent}`,
    z20: `0 20px 40px -4px ${transparent}`,
    z24: `0 24px 48px 0 ${transparent}`,
    //
    primary: `0 8px 16px 0 ${alpha(pal.primary.main, isLight ? 0.24 : 0.4)}`,
    info: `0 8px 16px 0 ${alpha(pal.info.main, isLight ? 0.24 : 0.4)}`,
    secondary: `0 8px 16px 0 ${alpha(pal.secondary.main, isLight ? 0.24 : 0.4)}`,
    success: `0 8px 16px 0 ${alpha(pal.success.main, isLight ? 0.24 : 0.4)}`,
    warning: `0 8px 16px 0 ${alpha(pal.warning.main, isLight ? 0.24 : 0.4)}`,
    error: `0 8px 16px 0 ${alpha(pal.error.main, isLight ? 0.24 : 0.4)}`,
    //
    card: isLight
      ? `0 0 2px 0 ${alpha(color, 0.2)}, 0 12px 24px -4px ${alpha(color, 0.12)}`
      : `0 0 2px 0 rgba(0,0,0,0.4), 0 12px 24px -4px rgba(0,0,0,0.6)`,
    dialog: `-40px 40px 80px -8px ${alpha(color, isLight ? 0.24 : 0.6)}`,
    dropdown: `0 0 2px 0 ${alpha(color, isLight ? 0.24 : 0.5)}, -20px 20px 40px -4px ${alpha(color, isLight ? 0.24 : 0.5)}`,
  };
}
